import { FC } from "react";

import { AlertsHistoryTable } from "src/components/Alerts/AlertsHistoryTable";
import { useGetCaseAlerts } from "src/graphql/anti-fraud/queries/cases/GetCaseAlertsQuery";

export type CaseAlertsHistoryProps = {
  caseId: string;
  caseNumber: string;
};

export const CaseAlertsHistory: FC<CaseAlertsHistoryProps> = ({ caseId, caseNumber }) => {
  const {
    data: alerts,
    loading,
    error,
  } = useGetCaseAlerts({
    variables: { id: caseId },
  });

  return (
    <AlertsHistoryTable
      alerts={alerts ?? []}
      isLoading={loading}
      isError={!!error}
      openInNewTab={true}
      caseNumber={caseNumber}
      scrollMode="inline"
    />
  );
};
